import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NavBarAuth from "../../../../components/navbar/navbarAuth";
import { IoIosAddCircleOutline } from "react-icons/io";
import { ImFilesEmpty } from "react-icons/im";
import axios from "axios";
import { BaseURL } from "../../../../Files/BaseURL";
import AlertContext from "../../../../Context/Alert/AlertContext";

function IdentityDoc() {
  const { id } = useParams();
  const [idFile, setIdFile] = useState(null);
  const [idBackFile, setIdBackFile] = useState(null);
  const [residencyFile, setResidencyFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;
  const navigate = useNavigate();

  const handleFileUpload = async () => {
    if (!idFile || !idBackFile || !residencyFile) {
      showAlert("Please upload all documents", "danger");
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("ID", idFile);
      formData.append("IDcardBack", idBackFile);
      formData.append("Residency", residencyFile);

      await axios.post(
        `${BaseURL}/api/auth/uploadVerificationDocs/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Show success message and navigate immediately
      showAlert("Documents uploaded successfully", "success");
      navigate(`/verify/${id}`);
    } catch (error) {
      showAlert("Error uploading files. Please try again", "danger");
      setIsLoading(false);
    }
  };

  // Cleanup effect
  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <>
      <NavBarAuth />
      <div className="bg-gray-100">
        <div className="w-[100%] h-2 bg-primarygreen rounded-r-full"></div>
      </div>
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 w-[95%] md:w-[60%] lg:w-[40%] bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-pop font-bold mb-4">
            Identity verification
          </h2>
{/* ID Card Front */}
          <div className="mb-4 flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <div className="bg-gray-200 rounded-full p-3">
                <img
                  src="../Assets/Prop/IDIcon.png"
                  className="w-5 h-5"
                  alt="ID Icon"
                />
              </div>
              <h2 className="text-2xl font-pop font-bold">ID Front</h2>
            </div>
            <p className="text-black font-light font-pop text-lg mb-2">
              Make sure your document has not expired. A passport, foreign
              passport or driver's license is suitable for identity
              verification.
            </p>

            <div className="flex w-full">
              <label
                htmlFor="id-file-front"
                className={`flex flex-col w-full border-2 border-primarygreen ${
                  idFile
                    ? "border-solid px-6"
                    : "border-dashed justify-center items-center"
                } rounded-lg cursor-pointer bg-transparent hover:bg-gray-100`}
              >
                {idFile ? (
                  <div className="flex flex-row gap-4 items-center justify-start py-3 text-primarygreen font-pop">
                    <ImFilesEmpty className="text-2xl" />
                    <p className="text-lg">{idFile.name}</p>
                  </div>
                ) : (
                  <div className="flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop">
                    <IoIosAddCircleOutline className="text-2xl" />
                    <p className="text-lg">Upload Front ID file</p>
                  </div>
                )}
                <input
                  id="id-file-front"
                  type="file"
                  className="hidden"
                  onChange={(e) => setIdFile(e.target.files[0])}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </label>
            </div>
          </div>

{/* ID Card BACK */}
          <div className="mb-4 flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <div className="bg-gray-200 rounded-full p-3">
                <img
                  src="../Assets/Prop/IDIcon.png"
                  className="w-5 h-5"
                  alt="ID Icon"
                />
              </div>
              <h2 className="text-2xl font-pop font-bold">ID Back</h2>
            </div>
            <p className="text-black font-light font-pop text-lg mb-2">
              Make sure your document has not expired. A passport, foreign
              passport or driver's license is suitable for identity
              verification.
            </p>

            <div className="flex w-full">
              <label
                htmlFor="id-file-back"
                className={`flex flex-col w-full border-2 border-primarygreen ${
                  idBackFile
                    ? "border-solid px-6"
                    : "border-dashed justify-center items-center"
                } rounded-lg cursor-pointer bg-transparent hover:bg-gray-100`}
              >
                {idBackFile ? (
                  <div className="flex flex-row gap-4 items-center justify-start py-3 text-primarygreen font-pop">
                    <ImFilesEmpty className="text-2xl" />
                    <p className="text-lg">{idBackFile.name}</p>
                  </div>
                ) : (
                  <div className="flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop">
                    <IoIosAddCircleOutline className="text-2xl" />
                    <p className="text-lg">Upload Back ID file</p>
                  </div>
                )}
                <input
                  id="id-file-back"
                  type="file"
                  className="hidden"
                  onChange={(e) => setIdBackFile(e.target.files[0])}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </label>
            </div>
          </div>

{/* Residence Field */}
          <div className="mb-4 flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <div className="bg-gray-200 rounded-full p-3">
                <img
                  src="../Assets/Prop/register.png"
                  className="w-5 h-5"
                  alt="Residency Icon"
                />
              </div>
              <h2 className="text-2xl font-pop font-bold">
                Residence registration
              </h2>
            </div>
            <p className="text-black font-light font-pop text-lg mb-2">
              Make sure your document has not expired. A passport, foreign
              passport or driver's license is suitable for identity
              verification.
            </p>

            <div className="flex items-center w-full">
              <label
                htmlFor="residency-file"
                className={`flex flex-col w-full border-2 border-primarygreen ${
                  residencyFile
                    ? "border-solid px-6"
                    : "border-dashed items-center justify-center"
                } rounded-lg cursor-pointer bg-transparent hover:bg-gray-100`}
              >
                {residencyFile ? (
                  <div className="flex flex-row gap-4 items-center justify-start py-3 text-primarygreen font-pop">
                    <ImFilesEmpty className="text-2xl" />
                    <p className="text-lg">{residencyFile.name}</p>
                  </div>
                ) : (
                  <div className="flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop">
                    <IoIosAddCircleOutline className="text-2xl" />
                    <p className="text-lg">Upload Residency file</p>
                  </div>
                )}
                <input
                  id="residency-file"
                  type="file"
                  className="hidden"
                  onChange={(e) => setResidencyFile(e.target.files[0])}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </label>
            </div>
          </div>

          <button
            onClick={handleFileUpload}
            disabled={isLoading}
            className={`${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            } my-4 w-full bg-green-500 hover:bg-transparent font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp`}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              </div>
            ) : (
              "Send"
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default IdentityDoc;
